
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"37","viewBox":"0 0 39 37","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.43 17.195L20.875.541a2.017 2.017 0 00-2.75 0L.571 17.195a1.777 1.777 0 000 2.61l17.554 16.654c.76.721 1.99.721 2.75 0l17.554-16.654c.761-.704.761-1.87 0-2.61zm-15.039 5.94v-4.626h-7.802v5.552h-3.9v-7.402c0-1.018.877-1.85 1.95-1.85h9.752v-4.627l6.827 6.477-6.827 6.476z"}})])
          )
        }
      }
    